export enum GROUPS {
    /**
     * @value Add a group name
     * @description Label for a text field asking user to add a group name. Use infinitive
     */
    ADD_A_GROUP_NAME = 'GROUPS.ADD_A_GROUP_NAME',
    /**
     * @value Add by group identifier
     */
    ADD_BY_EMAIL = 'ADMIN.GROUP.ADD_BY_EMAIL',
    /**
     * @value Insert group reference that contains groups of people. Ex: all@mycompany.com, 123456 or MyGroupName
     */
    ADD_BY_EMAIL_HELP = 'ADMIN.GROUP.ADD_BY_EMAIL_HELP',
    /**
     * @value Add by users
     */
    ADD_BY_USER = 'ADMIN.GROUP.ADD_BY_USER',
    /**
     * @value Dynamic groups via user attributes
     */
    ADD_BY_USER_ATTRIBUTES = 'ADMIN.GROUP.ADD_BY_USER_ATTRIBUTES',
    /**
     * @value Target user using their profile attributes
     */
    ADD_BY_USER_ATTRIBUTES_HELP = 'ADMIN.GROUP.ADD_BY_USER_ATTRIBUTES_HELP',
    /**
     * @value Select users one by one
     */
    ADD_BY_USER_HELP = 'ADMIN.GROUP.ADD_BY_USER_HELP',
    /**
     * @value Add a new group
     */
    ADD_NEW_GROUP = 'ADMIN.GROUPS.NEW',
    /**
     * @value Category name
     */
    CATEGORY_NAME = 'ADMIN.GROUPS.CATEGORY.NAME',
    /**
     * @value Copy group id
     */
    COPY_GROUP_ID = 'ADMIN.GROUP.COPY_GROUP_ID',
    /**
     * @value Platform groups
     */
    CUSTOMER_FEEDS = 'ADMIN.NAV.CUSTOMER_FEEDS',
    /**
     * @value Daily update
     */
    DAILY_UPDATE = 'ADMIN.UPDATE.DAILY',
    /**
     * @value User subscriptions rules
     */
    DYNAMIC_GROUPS_RULES_LIST = 'ADMIN.GROUP.DYNAMIC_GROUPS_RULES_LIST',
    /**
     * @value Targeted users will be synchronized within the next 24 hours.
     */
    DYNAMIC_GROUP_CONFIRM_DESCRIPTION = 'ADMIN.GROUP.DYNAMIC_GROUP_CONFIRM_DESCRIPTION',
    /**
     * @value Users Synchronization
     */
    DYNAMIC_GROUP_CONFIRM_TITLE = 'ADMIN.GROUP.DYNAMIC_GROUP_CONFIRM_TITLE',
    /**
     * @value Edit group
     */
    EDIT_GROUP = 'ADMIN.GROUP.EDIT_GROUP',
    /**
     * @value Groups
     */
    FEEDS = 'ADMIN.NAV.FEEDS',
    /**
     * @value Code
     */
    FEED_CODE = 'ADMIN_FEED_CODE',
    /**
     * @value Delete a group
     */
    FEED_DELETE = 'ADMIN_FEED_DELETE',
    /**
     * @value Are you sure you want to delete this group?
     */
    FEED_DELETE_DESCRIPTION = 'ADMIN_FEED_DELETE_DESCRIPTION',
    /**
     * @value Group name
     */
    FEED_NAME = 'ADMIN_FEED_NAME',
    /**
     * @value Group settings
     */
    FEED_SETTINGS = 'ADMIN_FEED_SETTINGS',
    /**
     * @value Synchronize users
     */
    FEED_SYNCHRONIZE = 'ADMIN_FEED_SYNCHRONIZE',
    /**
     * @value Users are being synchronized... Please wait a few minutes.
     */
    FEED_SYNCHRONIZE_SUCCESS = 'ADMIN_FEED_SYNCHRONIZE_SUCCESS',
    /**
     * @value Delete a group category
     */
    FEED_TYPE_DELETE = 'ADMIN_FEED-TYPE_DELETE',
    /**
     * @value Are you sure you want to delete this group category?
     */
    FEED_TYPE_DELETE_DESCRIPTION = 'ADMIN_FEED-TYPE_DELETE_DESCRIPTION',
    /**
     * @value Group category settings
     */
    FEED_TYPE_SETTINGS = 'ADMIN_FEED-TYPE_SETTINGS',
    /**
     * @value Add a user into the group
     */
    FEED_USER_ADD = 'ADMIN_FEED_USER_ADD',
    /**
     * @value Delete a user from a group
     */
    FEED_USER_DELETE = 'ADMIN_FEED_USER_DELETE',
    /**
     * @value Are you sure you want to delete this user from the group?
     */
    FEED_USER_DELETE_DESCRIPTION = 'ADMIN_FEED_USER_DELETE_DESCRIPTION',
    /**
     * @value Error while retrieving fields from User Directory
     */
    FETCH_DIRECTORY_FIELDS = 'ADMIN.GROUP.ERROR.FETCH_DIRECTORY_FIELDS',
    /**
     * @value Synchronize groups
     */
    GROUPS_SYNCHRONIZE = 'ADMIN.GROUPS.SYNCHRONIZE',
    /**
     * @value group id
     */
    GROUP_ID = 'ADMIN.GROUP.GROUP_ID',
    /**
     * @value Group identifier (identification number or email)
     */
    GROUP_MAIL = 'ADMIN.GROUP.GROUP_MAIL',
    /**
     * @value Users in the group
     */
    LIST_USER = 'ADMIN.GROUP.LIST_USER',
    /**
     * @value Examples of user profile fields
     */
    MAP_EXAMPLE = 'ADMIN.FEED_TYPE.MAP_EXAMPLE',
    /**
     * @value Method
     */
    METHOD = 'ADMIN.GROUP.METHOD',
    /**
     * @value This feature is based on the definition of user profile fields, you must first configure the main User Directory of your site.
     */
    MISSING_MAIN_USER_DIRECTORY_WARNING = 'ADMIN.GROUP.MISSING_MAIN_USER_DIRECTORY_WARNING',
    /**
     * @value See the <a href="https://docs.lumapps.com/docs/users-l23940673103242616"  target="_blank" class="tc-black-2">documentation</a> to create your own custom pattern
     */
    PATTERN_HELP = 'ADMIN.DIRECTORY_CUSTOM.PATTERN_HELP',
    /**
     * @value Provider's group not found
     */
    PROVIDER_GROUP_NOT_FOUND = 'ADMIN.GROUP.ERROR.PROVIDER_GROUP_NOT_FOUND',
    /**
     * @value Attribute
     */
    RULE_ATTRIBUTE_NAME = 'ADMIN.GROUP.RULE_ATTRIBUTE_NAME',
    /**
     * @value Select a profile attribute
     */
    RULE_ATTRIBUTE_PLACEHOLDER = 'ADMIN.GROUP.RULE_ATTRIBUTE_PLACEHOLDER',
    /**
     * @value Operator
     */
    RULE_OPERATOR_NAME = 'ADMIN.GROUP.RULE_OPERATOR_NAME',
    /**
     * @value Metadata values
     */
    RULE_VALUES_METADATA_NAME = 'ADMIN.GROUP.RULE_VALUES_METADATA_NAME',
    /**
     * @value Select metadata values
     */
    RULE_VALUES_METADATA_PLACEHOLDER = 'ADMIN.GROUP.RULE_VALUES_METADATA_PLACEHOLDER',
    /**
     * @value Values
     */
    RULE_VALUES_NAME = 'ADMIN.GROUP.RULE_VALUES_NAME',
    /**
     * @value Type a value then press `Enter`
     */
    RULE_VALUES_PLACEHOLDER = 'ADMIN.GROUP.RULE_VALUES_PLACEHOLDER',
    /**
     * @value Metadata value
     */
    RULE_VALUE_METADATA_NAME = 'ADMIN.GROUP.RULE_VALUE_METADATA_NAME',
    /**
     * @value Select a metadata value
     */
    RULE_VALUE_METADATA_PLACEHOLDER = 'ADMIN.GROUP.RULE_VALUE_METADATA_PLACEHOLDER',
    /**
     * @value Value
     */
    RULE_VALUE_NAME = 'ADMIN.GROUP.RULE_VALUE_NAME',
    /**
     * @value Type a value
     */
    RULE_VALUE_PLACEHOLDER = 'ADMIN.GROUP.RULE_VALUE_PLACEHOLDER',
    /**
     * @value Synchronization
     */
    SYNCHRONIZATION = 'ADMIN.GROUP.SYNCHRONIZATION',
    /**
     * @value Select a domain and enter a group identifier. Fields are case sensitive.
     */
    SYNCHRONIZATION_HELP = 'ADMIN.GROUP.SYNCHRONIZATION_HELP',
    /**
     * @value User profile field
     */
    USER_PROFILE_FIELD = 'ADMIN.FEED_TYPE.MAP',
    /**
     * @value Only metadata that are not used as directory fields are currently supported
     */
    WARNING_METADATA_DIRECTORY_FIELDS = 'ADMIN.GROUP.WARNING_METADATA_DIRECTORY_FIELDS',
}
